import React from "react"

import {useApartment} from "../ApartmentContext";
import {useApartmentAction} from "../ApartmentActionContext";
import CountryFlag from "../../../../../components/CountryFlag";
import TextAttributeForm from "../../../../../components/AttributeForm/TextAttributeForm";
import AttributeList from "../../../../../components/AttributeList";

const ApartmentDescription = () => {
    const {descriptionIt, descriptionEn,} = useApartment();
    const {formDescriptionIt, formDescriptionEn, handleAttributeUpdate} = useApartmentAction();

    const attributes = [
        {
            label: "Descrizione (italiano)",
            value: descriptionIt,
            defaultValue: "Non presente",
            icon: <CountryFlag code="IT"/>,
            formDialog: formDescriptionIt,
            formComponent: <TextAttributeForm attribute="descriptionIt"
                                              label="Descrizione (italiano)"
                                              value={descriptionIt}
                                              onClose={formDescriptionIt.close}
                                              onSubmit={(data) => handleAttributeUpdate(formDescriptionIt, data)}
                                              multiline={true}
                                              rows={10}
                                              isLoading={formDescriptionIt.loading}/>
        },
        {
            label: "Descrizione (inglese)",
            value: descriptionEn,
            defaultValue: "Non presente",
            icon: <CountryFlag code="GB"/>,
            formDialog: formDescriptionEn,
            formComponent: <TextAttributeForm attribute="descriptionEn"
                                              label="Descrizione (inglese)"
                                              value={descriptionEn}
                                              onClose={formDescriptionEn.close}
                                              onSubmit={(data) => handleAttributeUpdate(formDescriptionEn, data)}
                                              multiline={true}
                                              rows={10}
                                              isLoading={formDescriptionEn.loading}/>
        },
    ]

    return <AttributeList attributes={attributes}/>
}

export default ApartmentDescription;